module.exports = __webpack_public_path__ + "img/pc_popup.dcd029d5.png";